import { Single_ } from 'monica-alexandria';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import i18n from '../../../localization/i18next';

const read_language = () => {
    return i18n.language ? i18n.language : 'el';
};

export default function NO_ACCESS() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const language = read_language();

    return (
        <Single_
            backgroundImage="https://genius1071.friktoriaservers.net/doitforme/morning/app/griphook/NoAccess.svg"
            iconGrey="Lock"
            iconMain="Lock"
            onClickGrey={() => navigate(`/${language}`)}
            onClickMain="-"
            subtitle={t('Unauthorised access')}
            text={t('You are not authorized to view this page')}
            textGrey={t('Back to Offers')}
            title={t('Access denied')}
        />
    );
}
